import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

function GenerateSandboxModal({
  isOpen, onClose, onConfirm, loading = false, sandboxType = 'wms',
}) {
  if (!isOpen) return null;

  const typeLabel = sandboxType.toUpperCase();

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="modal-backdrop"
        onClick={onClose}
        onKeyDown={(e) => { if (e.key === 'Escape') onClose(); }}
        tabIndex={-1}
        aria-hidden="true"
      />
      <div className="modal max-w-sm">
        <div className="modal-header">
          <h2 className="text-lg font-semibold text-surface-900">Regenerate {typeLabel} Sandbox</h2>
        </div>
        <div className="modal-body">
          {loading ? (
            <div className="flex justify-center py-4"><ClipLoader /></div>
          ) : (
            <>
              <p className="text-sm text-surface-600 mb-2">This will reset the {typeLabel} sandbox environment to its default state.</p>
              <p className="text-sm text-surface-600">Are you sure you want to proceed?</p>
            </>
          )}
        </div>
        {!loading && (
          <div className="modal-footer">
            <button type="button" onClick={onClose} className="btn btn-secondary">Cancel</button>
            <button type="button" onClick={onConfirm} className="btn btn-primary">Confirm</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default GenerateSandboxModal;
